module.exports = __webpack_public_path__ + "img/1.b0da50f5.png";